/* Recargos atados a la taza.
   La segunda cara de la taza se cobra en su propia línea (_recargo) con el
   id del diseño (_diseno). El cliente no puede borrarla ni cambiarle la
   cantidad desde el carrito; aquí, cada vez que cambia el carrito, se
   iguala su cantidad a las tazas de ese diseño y, si ya no queda ninguna,
   se quita. Xavi: "he borrado los extras por imprimir el otro lado de la
   taza y me dejaba hacer el pedido igualmente". */
(function () {
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ajustando = false;

  function cuadrar() {
    if (ajustando) return Promise.resolve(false);
    ajustando = true;
    return fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var tazas = {}, updates = {};
        /* Merchandising con cantidad a medida: las unidades extra (_libre + _grupo) van atadas a su pack (mismo _grupo).
           Si borran el pack, las extra sobran y se quitan. */
        var grupos = {};
        (cart.items || []).forEach(function (it) {
          var g = it.properties && it.properties._grupo;
          if (g && !(it.properties && it.properties._libre)) grupos[g] = true;
        });
        (cart.items || []).forEach(function (it) {
          var p0 = it.properties || {};
          if (p0._grupo && p0._libre && !grupos[p0._grupo]) updates[it.key] = 0;
        });
        /* Chapas con cantidad a medida (property _libre): la cantidad la fija la ficha y el precio por chapa es el
           de su escalón. Si la cambian a mano (por ejemplo a 500 con el precio de las 50), se vuelve a la que era. */
        (cart.items || []).forEach(function (it) {
          var l = it.properties && it.properties._libre;
          var n = l ? parseInt(l, 10) : 0;
          if (n > 0 && it.quantity !== n && updates[it.key] !== 0) updates[it.key] = n;
        });
        (cart.items || []).forEach(function (it) {
          var p = it.properties || {};
          if (!p._diseno || p._recargo) return;
          tazas[p._diseno] = (tazas[p._diseno] || 0) + it.quantity;
        });
        (cart.items || []).forEach(function (it) {
          var p = it.properties || {};
          if (!p._recargo || !p._diseno) return;
          var n = tazas[p._diseno] || 0;
          if (n !== it.quantity) updates[it.key] = n;
        });
        /* Un recargo sin prenda ni nada más al lado es un resto: el cliente no puede quitarlo
           (no tiene botón) y el carrito se queda con una línea suelta de «Impresión en la camiseta».
           Pasa con las líneas sin _diseno, que el chequeo de arriba no puede atar a ninguna prenda. */
        var sueltas = (cart.items || []).filter(function (it) { return !(it.properties && it.properties._recargo); });
        if (!sueltas.length) {
          (cart.items || []).forEach(function (it) { if (it.properties && it.properties._recargo) updates[it.key] = 0; });
        }
        if (!Object.keys(updates).length) return false;
        return fetch(raiz + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { return true; });
      })
      .catch(function () { return false; })
      .then(function (cambio) { ajustando = false; return cambio; });
  }

  // vuelve a pintar el carrito (página o cajón) con lo que hay ahora
  function repintar() {
    ['cart-items', 'cart-drawer-items'].forEach(function (tag) {
      var el = document.querySelector(tag);
      if (el && el.onCartUpdate) el.onCartUpdate();
    });
  }

  function alCambiar(ev) {
    if (ev && ev.source === 'carrito-recargos') return;
    cuadrar().then(function (cambio) { if (cambio) repintar(); });
  }

  /* OJO: `PUB_SUB_EVENTS` se declara con `const` en constants.js, y un `const` global NO cuelga de `window`, así que
     `window.PUB_SUB_EVENTS` es siempre undefined. Con la comprobación de antes este script no se suscribía nunca: los
     recargos huérfanos solo se limpiaban al recargar la página, no al borrar una línea (Xavi, 05/10/2026: «¿no hay manera de
     quitar los restos cuando borras productos del carrito?»). Se comprueba por nombre, que sí ve los const globales. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, alCambiar);
  }
  /* Orden: el recargo (impresión extra) se pinta justo DEBAJO de su prenda, no encima. El carrito de Shopify lo ordena
     por el momento en que se añadió y el recargo entra antes. Se reordena en pantalla con el id del diseño (data-diseno). */
  function ordenar() {
    var filas = document.querySelectorAll('cart-items tr.cart-item[data-diseno]');
    if (!filas.length) return;
    var porDiseno = {};
    filas.forEach(function (tr) { (porDiseno[tr.dataset.diseno] = porDiseno[tr.dataset.diseno] || []).push(tr); });
    Object.keys(porDiseno).forEach(function (id) {
      var grupo = porDiseno[id], prendas = grupo.filter(function (t) { return !t.classList.contains('cart-item--recargo'); });
      var recargos = grupo.filter(function (t) { return t.classList.contains('cart-item--recargo'); });
      if (!prendas.length || !recargos.length) return;
      var ref = prendas[prendas.length - 1];
      recargos.forEach(function (r) {
        // ya está justo después de su prenda (o de otro recargo ya colocado): no se toca
        if (ref.nextElementSibling !== r) ref.parentNode.insertBefore(r, ref.nextElementSibling);
        ref = r;
      });
    });
  }
  /* Móvil: varias tallas del MISMO diseño = una sola tarjeta, con una fila por talla (talla, cantidad editable, papelera e
     importe). Es solo visual: cada talla sigue siendo su línea del carrito de Shopify, y sus controles (cantidad, borrar) se
     mueven a la fila sin tocarlos (en móvil y en PC), así que siguen funcionando. Las líneas sobrantes se ocultan (y se ponen antes de la
     principal para que el recargo siga justo debajo de la tarjeta). */
  function agrupar() {
    var movil = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
    var filas = document.querySelectorAll('cart-items tr.cart-item[data-diseno]:not(.cart-item--recargo):not([data-agrupada])');
    var porDiseno = {};
    filas.forEach(function (tr) { (porDiseno[tr.dataset.diseno] = porDiseno[tr.dataset.diseno] || []).push(tr); });
    Object.keys(porDiseno).forEach(function (id) {
      var g = porDiseno[id];
      // solo si de verdad son tallas distintas de la misma prenda
      var tallaDe = function (tr) {
        var r = null;
        tr.querySelectorAll('.cart-item__details dl .product-option').forEach(function (po) {
          var dt = po.querySelector('dt'), dd = po.querySelector('dd');
          if (dt && dd && /^talla/i.test(dt.textContent.trim())) { r = { el: po, txt: dd.textContent.trim() }; }
        });
        return r;
      };
      if (g.length < 2 || !g.every(tallaDe)) return;
      var princ = g[0];
      /* Tallas de menor a mayor: XS, S, M, L, XL, 2XL… y las numéricas (bebé en meses, niño en años) por su número. */
      var ORDEN = ['xxs', 'xs', 's', 'm', 'l', 'xl', '2xl', 'xxl', '3xl', 'xxxl', '4xl', 'xxxxl', '5xl', '6xl'];
      var alias = { xxl: '2xl', xxxl: '3xl', xxxxl: '4xl' };
      var rango = function (txt) {
        var t = txt.toLowerCase().replace(/\s+/g, '');
        if (alias[t]) t = alias[t];
        var i = ORDEN.indexOf(t);
        if (i >= 0) return 5000 + i;
        var n = parseFloat((t.match(/\d+([.,]\d+)?/) || [''])[0].replace(',', '.'));
        if (!isNaN(n)) return (/mes|^\d+m$/.test(t) ? 0 : 1000) + n;
        return 9000;
      };
      g = g.map(function (tr, i) { return { tr: tr, i: i, r: rango(tallaDe(tr).txt) }; })
        .sort(function (a, b) { return a.r - b.r || a.i - b.i; }).map(function (o) { return o.tr; });
      var lista = document.createElement('div');
      lista.className = 'cart-item__tallas';
      g.forEach(function (tr) {
        var t = tallaDe(tr);
        var fila = document.createElement('div');
        fila.className = 'cart-item__talla-fila';
        var et = document.createElement('span'); et.className = 'cart-item__talla-et'; et.textContent = 'Talla ' + t.txt;
        var cq = document.createElement('div'); cq.className = 'cart-item__talla-cant';
        var tdq = tr.querySelector('td.cart-item__quantity');
        while (tdq && tdq.firstChild) cq.appendChild(tdq.firstChild);
        var imp = document.createElement('div'); imp.className = 'cart-item__talla-imp';
        var tdt = tr.querySelector('td.cart-item__totals:not(.small-hide)');
        var pw = tdt && tdt.querySelector('.cart-item__price-wrapper');
        if (pw) imp.appendChild(pw);
        fila.appendChild(et); fila.appendChild(cq); fila.appendChild(imp);
        lista.appendChild(fila);
        tr.setAttribute('data-agrupada', tr === princ ? 'principal' : 'secundaria');
        if (tr !== princ) { tr.classList.add('cart-item--secundaria'); princ.parentNode.insertBefore(tr, princ); }
        var tl = tallaDe(tr); if (tl) tl.el.classList.add('cart-item__talla-oculta');
      });
      princ.classList.add('cart-item--grupo');
      var det = princ.querySelector('td.cart-item__details');
      if (movil) {
        // móvil: las tallas ocupan TODO el ancho de la tarjeta (debajo de la foto), no solo la columna de los detalles
        var tdl = document.createElement('td'); tdl.className = 'cart-item__tallas-td'; tdl.appendChild(lista); princ.appendChild(tdl);
      } else if (det) { det.appendChild(lista); det.colSpan = 3; }   // en PC la celda de detalles ocupa también las de cantidad e importe
    });
  }
  /* CANTIDADES CRUZADAS AL PAGAR (Xavi, 17/10/2026: un cliente pidió 2 M + 1 XL y el pago salió 1 M + 2 XL).
     El formulario del carrito manda las cantidades como `updates[]` y Shopify las asigna POR POSICIÓN (la 1.ª a la línea 1…).
     `agrupar` reordena las filas por talla (S, M, L…), pero las líneas del carrito van en otro orden (la última añadida primero),
     así que al pulsar «Finalizar compra» cada cantidad caía en la línea de otra talla. Aquí, al construir los datos del formulario,
     se reescriben los `updates[]` en el orden de las líneas (por `data-index`), sea cual sea el orden en pantalla. */
  document.addEventListener('formdata', function (ev) {
    try {
      var f = ev.target;
      var ins = f && f.querySelectorAll ? Array.prototype.slice.call(f.querySelectorAll('input[name="updates[]"]')) : [];
      if (ins.length < 2) return;
      var orden = ins.map(function (i, k) { return { n: parseInt(i.getAttribute('data-index'), 10), k: k, v: i.value }; });
      if (orden.some(function (o) { return isNaN(o.n); })) return;
      orden.sort(function (x, y) { return x.n - y.n || x.k - y.k; });
      ev.formData.delete('updates[]');
      orden.forEach(function (o) { ev.formData.append('updates[]', o.v); });
    } catch (e) { /* nunca debe impedir pagar */ }
  });
  var zona = document.querySelector('cart-items');
  if (zona && window.MutationObserver) {
    var tm2 = null;
    new MutationObserver(function () { clearTimeout(tm2); tm2 = setTimeout(agrupar, 20); }).observe(zona, { childList: true, subtree: true });
    agrupar();
  }
  if (zona && window.MutationObserver) {
    var tm = null;
    new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(ordenar, 30); }).observe(zona, { childList: true, subtree: true });
    ordenar();
  }
  // en la página del carrito, un repaso al cargar (por si se llegó con el carrito descuadrado)
  if (document.querySelector('cart-items')) alCambiar();
})();
